module.exports = require("./saq.d.ts");